import { z } from "zod";

export const MilestoneSchema = z.object({
  percent: z.number().int().min(0).max(100),
  emoji: z.string().min(1),
  label: z.string().min(1),
});

export type Milestone = z.infer<typeof MilestoneSchema>;

export const ObjectiveTargetSchema = z.discriminatedUnion("type", [
  z.object({
    type: z.literal("NUMBER"),
    value: z.number(),
    unit: z.string().optional(),
  }),
  z.object({
    type: z.literal("DURATION"),
    value: z.number().min(0),
    unit: z.literal("seconds").default("seconds"),
  }),
  z.object({
    type: z.literal("BOOLEAN"),
    value: z.boolean(),
    unit: z.string().optional(),
  }),
  z.object({
    type: z.literal("AMOUNT"),
    value: z.number(),
    unit: z.string().optional().default("EUR"),
  }),
  z.object({
    type: z.literal("FREQUENCY"),
    value: z.number().min(0),
    unit: z.string().optional(),
  }),
]);

export type ObjectiveTarget = z.infer<typeof ObjectiveTargetSchema>;

export const ObjectiveSchema = z.object({
  clientId: z.string().cuid(),
  title: z.string().min(1),
  description: z.string().optional(),
  recurrenceType: z
    .enum(["DAILY", "WEEKLY", "MONTHLY"])
    .optional()
    .default("DAILY"),
  startDate: z.coerce.date().optional().default(() => new Date()),
  endDate: z.coerce.date().optional().default(() => new Date()),
  progress: z.number().int().min(0).max(100).default(0),
  clientProgressEditable: z.boolean().optional().default(false),
  icon: z.string().optional(),
  milestones: z.array(MilestoneSchema).optional(),
  target: ObjectiveTargetSchema.optional(),
}).refine((v) => v.endDate >= v.startDate, {
  message: "endDate doit être >= startDate",
  path: ["endDate"],
});

export type ObjectiveDto = z.infer<typeof ObjectiveSchema>;
